import { createContextLocalStore } from '@/stores/local/createContextLocalStore';

import { OrganizationNewsPageStore } from './OrganizationNewsPageStore';

export * from './OrganizationNewsPageStore';

export const { Provider: OrganizationNewsPageStoreProvider, useStore: useOrganizationNewsPageStore } =
  createContextLocalStore(OrganizationNewsPageStore);
